import {Stack} from '@mui/material';
import Grid from '@mui/material/Grid2';
import {UnitCard} from 'presentation/modules/booking/shared/ui/components/UnitCard';
import {UnitNetworkHeader} from 'presentation/modules/booking/shared/ui/components/UnitNetworkHeader';
import {translations} from 'presentation/translations-new';
import React from 'react';
import {useOdontoUnitsSupportAccredited} from './hooks/useOdontoUnitsSupportAccredited';
import {OdontoUnitsSupportAccreditedNetworkProps} from './types';

const {accreditedNetwork} = translations['pt-br'].privateFlow.bookingFlow.unitsFlow;

export function OdontoUnitsSupportAccreditedNetwork({
	unitsList,
}: OdontoUnitsSupportAccreditedNetworkProps) {
	const {query, isMobile, specialtyName, shouldShowDistanceReference} =
		useOdontoUnitsSupportAccredited();

	return (
		<Stack gap={2}>
			<UnitNetworkHeader
				title={accreditedNetwork.title}
				description={accreditedNetwork.phoneScheduleDescription}
			/>

			<Grid container spacing={2}>
				{unitsList.units.unitsByLocality.map((unit, index) => {
					return (
						<Grid
							key={`${unit.name}-${unit.formattedAddress}${index}`}
							size={{xs: isMobile ? 12 : 6}}>
							<UnitCard
								query={query}
								isNotSelf={true}
								onClick={() => {}}
								unitName={unit?.name}
								address={unit?.formattedAddress}
								isTelemedicine={false}
								distanceReference={unit?.distance}
								specialtyName={specialtyName}
								phoneNumbers={unit?.phoneNumbers}
								showDistanceReference={shouldShowDistanceReference}
							/>
						</Grid>
					);
				})}
			</Grid>
		</Stack>
	);
}
